export default __webpack_public_path__ + "static/media/Calendar_Event_Delete.08b724c9.png";